<template>
  <div>
    <rs-dialog title="重置密码" :visible.sync="showDialogPassword" width="60%" :before-close="handleClose">
      <!-- 表格内容 -->
      <div style="margin-left:15vw">
        <renderForm :list="ruleForm" ref="ruleFormRef" :formData.sync="resetPasswordRow" :show-message="false">
          <template v-slot:status >
            <rs-form-item label="状态：">{{resetPasswordRow.status ? "已启用" : "已停用"}}</rs-form-item>
          </template>
        </renderForm>
      </div>
      <span slot="footer" class="dialog-footer">
        <rs-button @click="onButton('取消')" size="small">取 消</rs-button>
        <rs-button type="primary" @click="onButton('确定')" size="small">确 定</rs-button>
      </span>
    </rs-dialog>
  </div>
</template>

<script>
import Http from "@/api/account";
import mixin from "@/utils/mixin.js";
import Pagination from "./Pagination";
export default {
  props: {
    showDialogPassword: {
      type: Boolean,
      default: () => false,
    },
    resetPasswordRow: {
      default: () => {},
    },
  },
  components:{
    Pagination
  },
  mixins: [mixin],
  data() {
    return {
      ruleForm:[],
      value: false
    };
  },
  created(){
    this.renderPage()
  },
  watch: {},
  methods: {
    // 传递父级否则报错
    handleClose(done) {
      this.$emit("close");
    },
    // 判断点击弹窗确定和取消的按钮
    onButton(val){
      if(val ==="确定"){
        Http.resetPassword({id:this.resetPasswordRow.id}).then(res=>{
            console.log(res.data.code);
            if(res.data.code==200){
              this.$message({
                message: '重置成功，重置后的密码为123QWEasd',
                type: 'success'
              });
            }
          })
        this.$emit("close",this.value)
      }else{
        this.$emit("close")
      }
    },
    getData(){
    },
    renderPage(){
      this.ruleForm = [
        {
          type: "text",
          span: 24,
          label: "登录名：",
          key: "loginName"
        },
        {
          type: "text",
          span: 24,
          label: "员工名称：",
          key: "userName"
        },
        {
          type: "text",
          span: 24,
          label: "岗位名称：",
          key: "stationName"
        },
        {
          type: "text",
          span: 24,
          label: "所属组织：",
          key: "orgName"
        },
        {
          type: "text",
          span: 24,
          label: "手机：",
          key: "mobile"
        },
        {
          // type: "text",
          // span: 24,
          // label: "状态：",
          // key: "status"
          span: 24,
          slot: "status"
        }
      ]
    }
  },
};
</script>

<style lang="less">
.rs-tooltip__popper{
  font-size: 14px; max-width:87%
}
</style>